import React from 'react'
import { Drawer } from 'antd';
import BurgerSVG from 'assets/img/burger_black.svg'
import SuperEgoLogo from 'components/SuperEgoLogo'
import ProfileSnippet from '../../ProfileSnippet'
import MenuLeft from '../../MenuLeft'

import style from './style.module.scss'

class MobileMenu extends React.Component {
  state = {
    drawerIsVisible: false
  }

  closeDrawer = () => this.setState({ drawerIsVisible: false })

  showDrawer = () => this.setState({ drawerIsVisible: true })

  render() {
    return (
      <>
        <button
          onClick={this.showDrawer}
          className={style.button}
          type="button"
        >
          <img src={BurgerSVG} alt="" />
        </button>
        <Drawer
          width={250}
          placement="right"
          closable={false}
          onClose={this.closeDrawer}
          visible={this.state.drawerIsVisible}
          className={style.drawer}
        >
          <SuperEgoLogo className={style.logo} />
          <ProfileSnippet />
          <MenuLeft onMenuItemClick={this.closeDrawer} />
        </Drawer>
      </>
    )
  }
}

export default MobileMenu
